import update from 'immutability-helper';
import { ActionType, defaultAction } from 'src/redux/types';
import { CashInData, CashOutData } from '../types';
import { ACTION_TYPES } from './types';

export type ApiOfflineState = {
  cashOut: {
    list: {
      data: CashOutData[];
      error: string;
      isLoading: boolean;
      totalEntry: number;
      totalTaxFee: number;
    };
  };
  cashIn: {
    list: {
      data: CashInData[];
      error: string;
      isLoading: boolean;
      successTxCount: number;
      totalAdminFee: number;
      totalEntry: number;
      totalReceivedAmount: number;
      totalTxCount: number;
      totalTaxFee: number;
    };
  };
};

const initialState: ApiOfflineState = {
  cashOut: {
    list: {
      data: [],
      error: '',
      isLoading: false,
      totalEntry: 0,
      totalTaxFee: 0,
    },
  },
  cashIn: {
    list: {
      data: [],
      error: '',
      isLoading: false,
      successTxCount: 0,
      totalAdminFee: 0,
      totalEntry: 0,
      totalReceivedAmount: 0,
      totalTxCount: 0,
      totalTaxFee: 0,
    },
  },
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.API_OFFLINE_LOAD_CASHOUT_LIST:
      return update(state, {
        cashOut: {
          list: {
            isLoading: {
              $set: true,
            },
          },
        },
      });
    case ACTION_TYPES.API_OFFLINE_LOAD_CASHOUT_LIST_SUCCESS:
      return update(state, {
        cashOut: {
          list: {
            $set: {
              data: payload.data.data,
              error: '',
              isLoading: false,
              totalEntry: payload.data.total_entry,
              totalTaxFee: payload.data.total_tax_fee,
            },
          },
        },
      });
    case ACTION_TYPES.API_OFFLINE_LOAD_CASHOUT_LIST_FAILED:
      return update(state, {
        cashOut: {
          list: {
            error: {
              $set: payload.message,
            },
            isLoading: {
              $set: false,
            },
          },
        },
      });
    case ACTION_TYPES.API_OFFLINE_LOAD_CASHIN_LIST:
      return update(state, {
        cashIn: {
          list: {
            isLoading: {
              $set: true,
            },
          },
        },
      });
    case ACTION_TYPES.API_OFFLINE_LOAD_CASHIN_LIST_SUCCESS:
      return update(state, {
        cashIn: {
          list: {
            $set: {
              data: payload.data.data,
              error: '',
              isLoading: false,
              successTxCount: payload.data.success_cash_in_count,
              totalAdminFee: payload.data.total_admin_fee,
              totalEntry: payload.data.total_entry,
              totalReceivedAmount: payload.data.total_received_amount,
              totalTxCount: payload.data.total_cash_in_count,
              totalTaxFee: payload.data.total_tax_fee,
            },
          },
        },
      });
    case ACTION_TYPES.API_OFFLINE_LOAD_CASHIN_LIST_FAILED:
      return update(state, {
        cashIn: {
          list: {
            error: {
              $set: payload.message,
            },
            isLoading: {
              $set: false,
            },
          },
        },
      });
    default:
      return state;
  }
};

export type ColumnConfigSchema = {
  key: string;
  label: string;
};
